var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('UserDetails',{staticClass:"col-xl-8",attrs:{"group-code":_vm.groupCode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }